import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from '../../components/Button';
import Col from '../../components/Col';
import Form, { Heading } from '../../components/Form';
import Input from '../../components/Input';
import File from '../../components/File';
import Row from '../../components/Row';

import Select from '../../components/Select';
import { PATHS } from '../../common/constants';
import { signIn } from '../../store/actions/auth';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { throwStatement } from '@babel/types';




class ViewImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      old_password: '',
      new_password: '',
      confirm_password: ''

    }
  }
  componentDidMount() {

  }

  validatePasswordForm() {
    const { old_password, new_password, confirm_password } = this.state;



    if (new_password === confirm_password) {

      let data = {
        Username: this.props.user.email,
        Password: old_password
      }
      let newData = {
        "UserId": this.props.user.id,
        "Password": new_password,
        "NewPassword": confirm_password
      }
      let history = this.props.history
      this.props.signIn(data, history, newData)

    } else {
      alert('New Password and confirm password must be same !')
    }




  }
  navigteToMessages() {
    
    this.props.history.push(PATHS.SERVICE_REQUESTS_VIEW.replace(':id', this.props.location.state.serviceRequestId))
  }
  render() {
    const { old_password, new_password, confirm_password } = this.state;
    const { image,fileName } = this.props.location.state;
    const thumb = {
      display: 'inline-flex',
      borderRadius: 2,
      border: '1px solid #eaeaea',
      marginBottom: 8,
      marginRight: 8,
      width: 500,
      height: 300,
      padding: 4,
      boxSizing: 'border-box'
    };
    const thumbInner = {
      display: 'flex',
      minWidth: 0,
      overflow: 'hidden'
    };
    const img = {
      display: 'block',
      width: 500,
      height: 300
    };
    return (
      <Form
        headline={ fileName}
        onClose={() => this.navigteToMessages()}
        onSubmit={() => this.validatePasswordForm()}
        actions={(
          <>
            {/* <Button
              color="teal"
              size="small"
              label="Save Password"
              onClick={() => this.setState({
                buttonPressed: 'SaveAndClose'
              })}
              disabled={!old_password || !new_password || !confirm_password}

            /> */}
          </>
        )}
        component={(
          <>
            <Row mdCenter>
              <Col
                xs="12"
                md="6"
              >
                <Heading></Heading>
                <>
                  <div style={thumb} key={fileName}>
                    <div style={thumbInner}>
                      <img
                        src={image}
                        style={img}
                        alt={fileName}
                      />
                    </div>
                  </div>
                </>

              </Col>
            </Row>
          </>
        )}
      />
    );
  }
}

const mapStateToProps = state => ({
  user: selectAuthenticatedUser(state)
});

const mapDispatchToProps = dispatch => bindActionCreators({
  // signIn: signIn,

}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ViewImage);